import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomLogisticsTable from "../../CustomLogisticsTable";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import updateIcon from "../../../../../Assets/icons/check-circle (8) 1.svg";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import generateInvoiceIcon from "../../../../../Assets/icons/GenerateInvoice.svg";
import DetailsTable from "./DetailsTable";
import { Modal } from "react-bootstrap";
import { showCustomAlert } from "../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../customComponents/CustomLoader";
import { REACT_APP_API_BASE_URL } from "../../../../../constants/CommonAPI";

const OrderRecivedRequestDetails = () => {
  const [poApprovalEdit, setPoApprovalEdit] = useState([]);
  const [poId, setPoId] = useState(0);
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editRowId, setEditRowId] = useState(null); 
  const [editedQuantity, setEditedQuantity] = useState({}); 
  const navigate = useNavigate();
  const [quantityErrors, setQuantityErrors] = React.useState({});

  const [refno,setRefno]=useState()
  const [invoiceData,setInvoiceData]=useState([])
  const [editRow, setEditRow] = useState(null);
  const [productdetails, setProductDetails] = useState([]);
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};
  const searchtype = location?.state?.search_type;

  console.log("locationdata<><><>", location);
  const handleModalClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    fetchPoApprovalDetailsEdit();
  }, []);

  const fetchPoApprovalDetailsEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/edit/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data;

      console.log(fetchedData, "FETCHEDDATA");
      setPoApprovalEdit(fetchedData);
      const poIdVal = response.data.data.po_id;
      console.log(poIdVal, "POVALID");
      setPoId(poIdVal);

      console.log(formData, "depatartment DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (poId !== 0) {
      fetchProductDetails();
    }
  }, [poId]);

  const fetchProductDetails = async (page = 0, pageSize = 5) => {
    
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/podetails/list",
        {
          po_id: poId,
          is_invoice_generated: searchtype === 3 ? 0 : null,
          orderBy: "po_details_id asc",
          page,
          pageSize,
          listType:'recivereq',
          searchtype:searchtype

         
          
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data;

      console.log(formattedData, "formatdata");
      setProductDetails(formattedData);

      const quantities = formattedData.map((item) => item.po_details_id);
      console.log(quantities, "QuantValues");

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
    finally{
      setLoading(false)
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductDetails(newPage);
  };

  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Name",
    "Logistic Type",
    "Product Name",
    "Sub Product Name",
    "Tax Rate %",
    "Variant Name",
    "Quantity",
    "Quantity Accepted",
    "Price",
    "Tax Amount",
    "Total Price",
    "Invoice ID",
    "Action",
  ];

  const DEPARTMENT_KEY_MAPPING = {
    Name: "name",
    "Logistic Type": "itemtypename",
    "Product Name": "product_name",
    "Sub Product Name": "subproduct_name",
    "Tax Rate %": "tax",
    "Model Name": "model_name",
    "Variant Name": "variant_name",
    Quantity: "qty_approved",
    "Quantity Accepted": "accepted_qty",
    Price: "rate",
    "Tax Amount": "taxset_amount",
    "Total Price": "totalprice",
    "Invoice ID":"po_recvinvoice_id",
    Action: [
      {
        type: "generateinvoice",
        icon: searchtype === 3 && generateInvoiceIcon,
        label: "Generate Icon",
      },
      {
        type: "edit",
        icon:
          searchtype === 1 ? (editRow !== null ? updateIcon : editIcon) : null,
        label: "Edit",
      },
      {
        type: "downloadinvoice",
        icon: searchtype === 2 && downloadIcon,
        label: "download Icon",
      },
     
    ],
  };

  const handleEditClick = (row) => {
    console.log(row.po_details_id, "row");
    setEditRowId(row.po_details_id);
    setEditedQuantity({ [row.po_details_id]: row.accepted_qty });
  };
  const handleModalOpen = (row) => {
    setInvoiceData(row)
    setRefno()
   setShowModal(true)
  };
 
  const handleGenerateInvoice = async(row)=>{
    console.log("rowdata>>>",row);
    const TotalAmount = cleanAmount(invoiceData?.totalprice)
    const payload = {
      po_details_id: invoiceData.po_details_id,
      business_partner_id: invoiceData?.business_partner_id,
      po_id: invoiceData?.po_id,
      refno:refno,
      invoice_qty:invoiceData?.accepted_qty,
      invoice_amount:String(TotalAmount)
    };
    console.log("payload",payload);
    

    try {
      const response = await axiosInstance.post(
        `/poreceivedinvoice/receiveinvoice`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowModal(false)
      fetchProductDetails();
  
    } catch (error) {
      console.log(error);
    }
  }
  // const handleDownloadInvoice = async(row)=>{
  //   const encodedPoDetailsId = btoa(row?.po_details_id.toString());
  //   try {
  //     const response = await axiosInstance.get(
  //       `/purchaseorder/purchaseOrderDetailsDownload/${encodedPoDetailsId}`,
        
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
        
        
  //     );
  //     console.log("response",response);
     
  
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  const handleDownloadInvoice = async (row) => {
    try {
      // Convert po_details_id to Base64
      const encodedPoDetailsId = btoa(row?.po_details_id.toString());
  
      // Construct the URL
      const url = `${REACT_APP_API_BASE_URL}/purchaseorder/purchaseOrderDetailsDownload/${encodedPoDetailsId}`;
  
      // Open the URL in a new tab
      window.open(url, "_blank");
  
    } catch (error) {
      console.log(error);
    }
  };
  const cleanAmount = (amount) => {
    if (typeof amount === 'string') {
      return parseFloat(amount.replace(/[₹,]/g, '').trim()) || 0;
    }
    return amount; // If it's already a number, return it as-is
  };
  // const handleQuantityChange = (e, rowId) => {
  //   const newQuantity = e.target.value; // Capture the input as a string
  
  //   if (
  //     newQuantity === "" ||
  //     isNaN(newQuantity) ||
  //     parseInt(newQuantity) <= 0
  //   ) {
  //     // Handle invalid input case
  //     console.warn("Invalid quantity input:", newQuantity);
  //     setEditedQuantity({ ...editedQuantity, [rowId]: newQuantity }); // Still update the state with the current input
  //     return;
  //   }
  
  //   // Convert the input to an integer after validation
  //   const validQuantity = parseInt(newQuantity, 10);
  
  //   // Find the row in productdetails to calculate new values
  //   const rowToUpdate = productdetails.find(
  //     (item) => item.po_details_id === rowId
  //   );
  //   console.log(rowToUpdate, "ROWTOUPDATE");
  
  //   if (rowToUpdate) {
  //     // Clean and convert the rate and any other amounts using the cleanAmount function
  //     const rate = cleanAmount(rowToUpdate.rate); // Using cleanAmount
  //     const tax = cleanAmount(rowToUpdate.tax) / 100; // Convert tax to decimal format
  
  //     console.log("rate", rate);
  
  //     // Recalculate the total price and tax amount
  //     const total = validQuantity * rate;
  //     console.log(total, "TOTALVALUE");
  //     const taxAmountValue = total * tax;
  
  //     const newTaxAmount = taxAmountValue;
  //     const newTotalPrice = newTaxAmount + total;
  
  //     // Update the state with the new calculated values
  //     setProductDetails((prevDetails) =>
  //       prevDetails.map((item) =>
  //         item.po_details_id === rowId
  //           ? {
  //               ...item,
  //               qty_approved: validQuantity,
  //               totalprice: newTotalPrice,
  //               taxset_amount: newTaxAmount,
  //             }
  //           : item
  //       )
  //     );
  
  //     setEditedQuantity({ ...editedQuantity, [rowId]: validQuantity }); // Update the quantity for the specific row
  //   }
  // };  
  
  // const handleQuantityChange = (e, rowId) => {
  //   const newQuantity = e.target.value;

  //   if (
  //     newQuantity === "" ||
  //     isNaN(newQuantity) ||
  //     parseInt(newQuantity) <= 0
  //   ) {
     
  //     console.warn("Invalid quantity input:", newQuantity);
  //     setEditedQuantity({ ...editedQuantity, [rowId]: newQuantity }); 
  //     return;
  //   }
  //   const validQuantity = parseInt(newQuantity, 10);
  //   const rowToUpdate = productdetails.find(
  //     (item) => item.po_details_id === rowId
  //   );

  //   if (rowToUpdate) {
  //     const rate = cleanAmount(rowToUpdate.rate); 
  //     const tax = cleanAmount(rowToUpdate.tax) / 100; 
  //     const total = validQuantity * rate;
  //     console.log(total, "TOTALVALUE");
  //     const taxAmountValue = total * tax;

  //     const newTaxAmount = taxAmountValue;
  //     const newTotalPrice = newTaxAmount + total;

  //     setProductDetails((prevDetails) =>
  //       prevDetails.map((item) =>
  //         item.po_details_id === rowId
  //           ? {
  //               ...item,
  //               accepted_qty: validQuantity,
  //               totalprice: newTotalPrice,
  //               taxset_amount: newTaxAmount,
  //             }
  //           : item
  //       )
  //     );

  //     setEditedQuantity({ ...editedQuantity, [rowId]: validQuantity }); 
  //   }
  // };
  const handleQuantityChange = (e, rowId) => {
    const newQuantity = e.target.value;
  
    // Validation check for empty input, NaN, or non-positive quantity
    if (newQuantity === "" || isNaN(newQuantity) || parseInt(newQuantity) <= 0) {
      console.warn("Invalid quantity input:", newQuantity);
  
      // Set validation error message
      setQuantityErrors((prevState) => ({
        ...prevState,
        [rowId]: "Quantity should be greater than 0",
      }));
  
      // Update edited quantity state
      setEditedQuantity({ ...editedQuantity, [rowId]: newQuantity });
      return;
    }
  
    // Clear the error if the input is valid
    setQuantityErrors((prevState) => ({
      ...prevState,
      [rowId]: "",
    }));
  
    const validQuantity = parseInt(newQuantity, 10);
    const rowToUpdate = productdetails.find((item) => item.po_details_id === rowId);
  
    if (rowToUpdate) {
      const rate = cleanAmount(rowToUpdate.rate); // Clean rate
      const tax = cleanAmount(rowToUpdate.tax) / 100; // Tax percentage
      const total = validQuantity * rate;
      console.log(total, "TOTALVALUE");
  
      const taxAmountValue = total * tax;
      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;
  
      // Update product details
      setProductDetails((prevDetails) =>
        prevDetails.map((item) =>
          item.po_details_id === rowId
            ? {
                ...item,
                accepted_qty: validQuantity,
                totalprice: newTotalPrice,
                taxset_amount: newTaxAmount,
              }
            : item
        )
      );
  
      // Update edited quantity
      setEditedQuantity({ ...editedQuantity, [rowId]: validQuantity });
    }
  };
  


  const handleSave = async (row) => {
    console.log(
      "Saving Quantity for row:",
      row.po_details_id,
      "New Quantity:",
      editedQuantity[row.po_details_id]
    );
  
    const rowToUpdate = productdetails.find(
      (item) => item.po_details_id === row.po_details_id
    );
  
    if (rowToUpdate) {
      const newQuantity = editedQuantity[row.po_details_id];
      if (quantityErrors[row.po_details_id]) {
        console.error("Cannot save. Fix quantity errors first.");
        return; // Exit the function without calling the API
      }
      // Clean and convert the rate and tax using the cleanAmount function
      const rate = cleanAmount(rowToUpdate.rate); // Clean the rate
      const tax = cleanAmount(rowToUpdate.tax) / 100; // Clean and convert tax to decimal
  
      // Recalculate the total price and tax amount
      const total = newQuantity * rate;
      const taxAmountValue = total * tax;
      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;
  
     // Prepare payload for saving
         const payload = {
        accepted_qty: newQuantity,
        totalprice: String(newTotalPrice),
        taxset_amount: String(newTaxAmount),
      };
  
      try {
        const response = await axiosInstance.patch(
          `/purchaseorderacceptqty/acceptPoapproval/${row.po_details_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response, "EDITQUANTRESPONSE");
        if(response.status===200){
          fetchProductDetails();
        }
        // Update productdetails state with new values
        setProductDetails((prevDetails) =>
          prevDetails.map((item) =>
            item.po_details_id === row.po_details_id
              ? {
                  ...item,
                  qty_approved: newQuantity,
                  totalprice: newTotalPrice,
                  taxset_amount: newTaxAmount,
                }
              : item
          )
        );
      } catch (error) {
        console.log(error);
      }
  
      // After saving, reset the edit state
      setEditRowId(null);
    }
  };
  // const handleSave = async (row) => {
  //   console.log(
  //     "Saving Quantity for row:",
  //     row.po_details_id,
  //     "New Quantity:",
  //     editedQuantity[row.po_details_id]
  //   );

  //   const rowToUpdate = productdetails.find(
  //     (item) => item.po_details_id === row.po_details_id
  //   );

  //   if (rowToUpdate) {
     

  //     const newQuantity = editedQuantity[row.po_details_id];

  //     const total = newQuantity * rowToUpdate.rate;
  //     const taxAmountValue = total * (rowToUpdate.tax)/100;
  //     const newTaxAmount = taxAmountValue;
  //     const newTotalPrice = newTaxAmount + total;

      
  //     const payload = {
  //       accepted_qty: newQuantity,
  //       totalprice: String(newTotalPrice),
  //       taxset_amount: String(newTaxAmount),
  //     };

  //     try {
  //       const response = await axiosInstance.patch(
  //         `/purchaseorderacceptqty/acceptPoapproval/${row.po_details_id}`,
  //         payload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       console.log(response, "EDITQUANTRESPONSE");

  //       setProductDetails((prevDetails) =>
  //         prevDetails.map((item) =>
  //           item.po_details_id === row.po_details_id
  //             ? {
  //                 ...item,
  //                 accepted_qty: newQuantity,
  //                 totalprice: newTotalPrice,
  //                 taxset_amount: newTaxAmount,
  //               }
  //             : item
  //         )
  //       );
  //       fetchPoApprovalDetailsEdit();
  //       fetchProductDetails();
  //     } catch (error) {
  //       console.log(error);
  //     }

  //     setEditRowId(null);
  //   }
  // };

  const handleApprove = () => {
    showCustomAlert({
      title: "Success",
      text: "Are you sure you want to accept the order?",
      icon: "success",
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel",
      callback: async () => {
        try {
          const payload = {
            is_order_received: 1,
          };
  
          const response = await axiosInstance.patch(
            `/purchaseorderaccept/acceptorder/${data.po_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          if (response.status === 200) {
            // Show success alert after API call is successful
            navigate("/logistics/manage-order/order-recieved-request")
  
          }
  
          console.log(response, "RESPONSE");
        } catch (error) {
          console.log(error, "error");
        }
      },
    });
  };

  // const handleApprove = async () => {
  //   try {
  //     const payload = {
  //       is_order_received: 1,
  //     };

  //     const response = await axiosInstance.patch(
  //       `/purchaseorderaccept/acceptorder/${data.po_id}`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }

  //     );

  //     if( response.status === 200 ){
  //       showCustomAlert({
  //         title: "Success",
  //         text:"Are you sure you want to accept order.",
  //         confirmButtonText: " Order has been accepted successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //         callback: () => {
  //           navigate('/logistics/manage-order/order-recieved-request'); // Navigate after user clicks OK
  //         },
  //       });
  //     }

  //     console.log(response, "RESPONSE");
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className="">
        <div
          style={{
            paddingBottom: "35px",
            borderBottom: "1px solid lightgray",
            padding: "35px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <span
              style={{
                fontWeight: "300",
                fontSize: "12px",
                paddingBottom: "5px",
                color: "gray",
                paddingLeft: "15px",
              }}
            >
              Logistic / Orders Received Request / Orders Received Request
              Details
            </span>
            <div className="backbutton" onClick={() => navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitleDetails">
                {" "}
                Orders Received Request Details
              </span>
            </div>
          </div>
          {searchtype === 1 && (
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {/* <button className='clear-btn' style={{padding:"12px 28px", borderRadius:"38px", color:"green"}} >Back</button> */}
              <button
                className="flte-btn"
                style={{ padding: "12px 18px", borderRadius: "38px" }}
                onClick={handleApprove}
              >
                Accept Order
              </button>
            </div>
          )}
        </div>

        <div>
          <div className="">
            <h5
              style={{ paddingLeft: "55px" }}
              className="mt-2 mb-2 header-details"
            >
              Purchase Order
            </h5>
            <div
              className="detail-grid"
              style={{
                paddingBottom: "30px",
                borderBottom: "1px solid lightgray",
                paddingLeft: "57px",
                paddingTop: "15px",
              }}
            >
              <div className="details-item">
                <span className="details-label">PO Number</span>
                <span className="details-value">
                  {" "}
                  {poApprovalEdit.po_number}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">PO Date</span>
                <span className="details-value">{poApprovalEdit.po_date} </span>
              </div>
              <div className="details-item">
                <span className="details-label">Purchase Order Type</span>
                <span className="details-value">{poApprovalEdit.po_type} </span>
              </div>
              <div className="details-item">
                <span className="details-label">Vendor Name</span>
                <span className="details-value">
                  {poApprovalEdit.companyname}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Ref. No.</span>
                <span className="details-value">
                  {poApprovalEdit.reference_no}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Department</span>
                <span className="details-value">
                  {poApprovalEdit.department_name}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Term</span>
                <span className="details-value">
                  {poApprovalEdit.payment_term_name}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Type</span>
                <span className="details-value">
                  {poApprovalEdit.payment_mode}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">PO Expected Date</span>
                <span className="details-value">
                  {poApprovalEdit.po_expected_date}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Date</span>
                <span className="details-value">
                  {poApprovalEdit.payment_date}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Total</span>
                <span className="details-value">{poApprovalEdit.total} </span>
              </div>
            </div>

            <div style={{ paddingTop: "14px" }}>
              <DetailsTable
                data={productdetails}
                headers={DEPARTMENT_TABLE_HEADERS}
                keyMapping={DEPARTMENT_KEY_MAPPING}
                itemsPerPage={5}
                onPageChange={handlePageChange}
                handleEditClick={handleEditClick}
                handleGenerateButton={handleModalOpen}
                handleDownloadButton={handleDownloadInvoice}
                handleQuantityChange={handleQuantityChange}
                handleSave={handleSave}
                editRowId={editRowId}
                setEditRowId={setEditRowId}
                editedQuantity={editedQuantity}
                setEditedQuantity={setEditedQuantity}
                updateIcon={updateIcon}
                quantityErrors={quantityErrors}
              />
            </div>
            {showModal  && (
        <Modal show={showModal} handleClose={handleModalClose}>
          <span className='modalheading'>Enter Reference Number</span>
          <input
            type="text"
            placeholder="Enter Reference Number"
            value={refno}
            onChange={(e)=>setRefno(e.target.value)}
            className="leadmodalsearch mt-2 mb-2"
          
            
          />
       
          <div className='modalbuttons mt-2 mb-2'>
            <button onClick={handleModalClose} className='leadbtn'>Cancel</button>
            <button onClick={handleGenerateInvoice} className='leadbtn'>Generate Invoice</button>
          </div>
        </Modal>
      )}
          </div>
        </div>
      </div>
      </div>
    )}
    </div>
  );
};

export default OrderRecivedRequestDetails;
